module.exports = __webpack_public_path__ + "img/detractors.e029f96b.svg";